/**
 * Pins the Smile.io launcher button's size to the same deterministic
 * 60px/50px split (at the theme's usual 990px breakpoint) that
 * gorgias-widget-override.js forces on the Gorgias chat button, so the two
 * floating buttons always match. Smile.io has its own native responsive
 * sizing (60px down to ~830px, then 44px below that - not the same tiers
 * Gorgias uses), so left alone the two never line up at most widths.
 *
 * #smile-ui-lite-launcher-frame-container lives in the main document (not
 * an iframe), but Smile keeps rewriting its inline width/height/bottom on
 * its own resize handling, so - like the Gorgias override - a one-time fix
 * doesn't stick. A MutationObserver watching its "style" attribute plus a
 * slow poll fallback keep re-asserting it.
 *
 * This is done with a `transform: scale()` on the container rather than
 * overriding its width/height directly: the actual <button> rendered
 * inside (in a same-origin child iframe) is sized and positioned by Smile
 * to match whatever size Smile itself picked, independent of the outer
 * container - forcing just the container's width/height left that inner
 * button oversized/clipped or floating off-center inside it. A transform
 * scales the container's whole rendered output (iframe contents included)
 * as one unit, so the button inside stays centered and proportional no
 * matter what size Smile currently thinks it's using.
 * This depends on Smile's current internal markup, not a supported API, so
 * it can silently stop working after a Smile.io app update.
 */
(function () {
  var CONTAINER_ID = "smile-ui-lite-launcher-frame-container";
  var POLL_MS = 150;
  var SIZE_BREAKPOINT = 990;
  var SIZE_LARGE = 60;
  var SIZE_SMALL = 50;

  function applySize() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;

    var target = window.innerWidth >= SIZE_BREAKPOINT ? SIZE_LARGE : SIZE_SMALL;
    // `width` isn't affected by a transform we applied earlier, so this
    // always reads Smile's own current (unscaled) size, whatever it is.
    var nativeWidth = parseFloat(getComputedStyle(container).width);
    if (!nativeWidth) return;

    var transformValue = "scale(" + (target / nativeWidth).toFixed(4) + ")";
    if (container.style.getPropertyValue("transform") === transformValue) return;

    container.style.setProperty("transform", transformValue, "important");
    // Fixed, anchored bottom-right (right/bottom offsets) - scale from
    // that corner so it doesn't visibly shift.
    container.style.setProperty("transform-origin", "bottom right", "important");
  }

  var observedTarget = null;

  function ensureObserver() {
    // Scope to Smile's own wrapper once it exists, instead of the whole
    // document, so this isn't reacting to every inline-style change on the
    // page (animations, sliders, etc.) - just Smile's own subtree.
    var target =
      document.getElementById("smile-ui-lite-container") || document.body;
    if (observedTarget === target) return;
    observedTarget = target;
    var observer = new MutationObserver(applySize);
    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"],
    });
  }

  applySize();
  ensureObserver();
  setInterval(function () {
    applySize();
    ensureObserver();
  }, POLL_MS);
})();
